import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {KontakDataPribadiComponent} from "./kontak-data-pribadi.component";

const routes: Routes = [
  {
    path: 'kontak-data-pribadi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: KontakDataPribadiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KontakDataPribadiRoutingModule { }
